import $ from 'jquery';
import _ from '_';
import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
import ChoiceStore from './choice-store';
import cx from 'classnames';
import CheckmarkIcon from 'grommet/components/icons/base/Checkmark';
import CloseIcon from 'grommet/components/icons/base/Close';

export default class QnaResults extends React.Component {    
    constructor(props) {
        super(props);
    }
    getChoices(){
        let hasCorrectChoice = this.props.question.choices.find( (choice)=>{
            return choice.correct==true;
        })
        let choices = this.props.question.choices.sort( (choiceA, choiceB)=>{
            return choiceA.displayOrder - choiceB.displayOrder;
        });

        let choicesMap = choices.map( (choice,index) => {
            let componentProps = {
                key: "choice-"+index,
                choice: choice,
                score: this.props.question.score || hasCorrectChoice!=null,
                answered: this.props.question.answered
            }
            /*
            if(choice.selected || this.props.question.score){
                return ( <Choice {...componentProps} /> )
            }
            */
            return ( <Choice {...componentProps} /> )
        });
        return choicesMap;
    }

    render() { 
        
        //if(choices.length==0 && this.props.question.responseText==null) return false;
        if(this.props.question.displayType==5 || this.props.question.displayType==4){
            return(
                <ResponseText text={this.props.question.responseText} />
            )
        }
        else{
            let choices = this.getChoices();
            return(
                <ul className="qna-results result-choices choices-container">
                { choices }
                </ul>
            )
        }
    }
}
QnaResults.propTypes={
    question: React.PropTypes.object.isRequired
}

QnaResults.defaultProps={
}

class Choice extends React.Component{
    constructor(props) {
        super(props);
        this.state = props.choice;
    }

    getIcon(){

        if(this.props.score && this.state.correct){
            return (
                <span className="choice-icon correct-choice"><CheckmarkIcon /></span>
            )
        }
        else if(this.props.score && this.state.selected && !this.state.correct){
            return (
                <span className="choice-icon wrong-choice"><CloseIcon /></span>
            )
        }
        else{
            return (
                <span className="choice-icon"></span>
            )
        }
    }

    render() {
        let correct = this.state.correct;
        let className = cx({
            "choice-item": true,
            "active": this.state.selected,
            "correct": correct || (!this.props.score && this.state.selected),
            "incorrect-choice": this.props.score && this.state.selected && !correct 
        });
        let choiceId = `choice-${this.state.choiceId}`;
        let text = {
            __html: this.state.choiceText
        }
        const barStyle = {
            width: "100%"
        }

        let ChoiceIcon = this.getIcon();
        return(
            <li className={className}>
                <div className="result-container">
                    {ChoiceIcon}
                    <span className="choice-text" dangerouslySetInnerHTML={text}></span>
                    <div className="bar" style={barStyle}></div>
                </div>
            </li>
        )
    }
}

Choice.propTypes={
    choice: React.PropTypes.object.isRequired,
    score: React.PropTypes.bool
}
Choice.defaultProps={
    score: false
}

class ResponseText extends React.Component{
    constructor(props) {
        super(props);
    }

    render() {
        let className = cx({
            "choice-item": true,
            "active": true,
            "correct": true
        });
        const barStyle = {
            width: "100%"
        }
        return(
            <ul className="qna-results result-choices choices-container response-text">
                <li className={className}>
                    <div className="result-container">
                        <span className="choice-text">{this.props.text}</span>
                        <div className="bar" style={barStyle}></div>
                    </div>
                </li>
            </ul>
        )
    }
}

ResponseText.propTypes={
    text: React.PropTypes.string
}
ResponseText.defaultProps={
}


// WEBPACK FOOTER //
// ./medscape_modules/qna/form-components/choices/qna-results.jsx